import {IBistasDB, IDomaenenDB, IErgebnisseDB, IGruppenDB, ILoesungshaeufigkeitenDB, ISchueler_gruppenDB, ISchueler_testsDB, ISchuelerDB, IStufenDB, ITesthefteDB, IVergleichsgruppen_nwDB} from "./InterfacesDB";
import {IGruppe, ILoesungshaeufigkeiten, ISchueler_testsAPI, ISessionvariablen, IStatus, ITestheftAPI, ITestheftvarianten, TFach, TGruppentyp} from "./Interfaces";
import VeraApi from "./VeraApi";
import Tresor from "./Tresor";
import StammklasseAnpassenModal from "./modals/StammklasseAnpassenModal";
import KursAnpassenModal from "./modals/KursAnpassenModal";
import Utilities from "./Utilities";
import Hauptmenu from "./Hauptmenu";
import Modal from "./Modal";
import LerngruppeAnpassenModal from "./modals/LerngruppeAnpassenModal";
import TooltipItem from './TooltipItem';
import TooltipAufgabe from './TooltipAufgabe';
import Tooltip from './Tooltip';

export default class Veraportal {
    public sessionvariablen: ISessionvariablen;
    public hauptmenu: Hauptmenu = null;
    public tresor: Tresor = null;

    private _schulstatus: IStatus = null;
    private _schuelerliste: ISchuelerDB[] = [];
    private _gruppenliste: (IGruppe & { selected?: boolean })[] = [];
    private _schuelerGruppenZuweisungen: ISchueler_gruppenDB[] = [];
    private _testheftliste: ITestheftAPI[] = [];
    private _testliste: ISchueler_testsAPI[] = [];
    private _domaenenliste: IDomaenenDB[] = [];
    private _stufengrenzenliste: IStufenDB[] = [];
    private _bistas: IBistasDB[] = [];
    private _lhItemebeneVergleichsgruppenliste: ILoesungshaeufigkeitenDB[] = [];
    private _vergleichsgruppenNwListe: IVergleichsgruppen_nwDB[] = [];
    protected tooltipItem: TooltipItem | null = null;
    private tooltipAufgabe: TooltipAufgabe | null = null;

    private _testheftVarianten: ITestheftvarianten[] = []; // wird aus Testheftliste automatisch generiert (CBT-Duplikat etc.)

    protected druckansicht: boolean = false;

    //region getters / setters
    /**
     * Gibt die vom Server vorgegebene simulierte Portalzeit oder die aktuelle Systemzeit zurück.
     * Die Portalzeit darf nur für fachliche Länderfristen verwendet werden, nicht für technische Zeitmessungen.
     */
    public get portalzeit(): Date {
        return new Date(this.sessionvariablen?.projekt?.simulierte_portalzeit ?? Date.now());
    }

    public get schulstatus() {
        return this._schulstatus;
    }

    public set schulstatus(value) {
        this._schulstatus = value;
        this.benachrichtigungssymbolAktualisieren();
    }

    public get schuelerliste() {
        return this._schuelerliste;
    }

    public set schuelerliste(value) {
        this._schuelerliste = value;
    }

    public get gruppenliste() {
        return this._gruppenliste;
    }

    public set gruppenliste(value) {
        this._gruppenliste = value;
    }

    public get schuelerGruppenZuweisungen() {
        return this._schuelerGruppenZuweisungen;
    }

    public set schuelerGruppenZuweisungen(value) {
        this._schuelerGruppenZuweisungen = value;
    }

    public get testheftliste() {
        return this._testheftliste;
    }

    public set testheftliste(value) {
        this._testheftliste = value;

        this.testheftVarianten = [];

        if (this.sessionvariablen.projekt.weiche === 'vera8') {
            // Papiervariante
            if (this.schulstatus.is_cbt_schule_mathematik === null || this.schulstatus.is_cbt_schule_mathematik === 0) {
                this.testheftVarianten.push(
                    ...Utilities.cloneObject(
                        this.testheftliste.filter((t) => {
                            return t.is_pp === 1
                        }).map((t: any) => {
                            t.cbt = false;
                            t.erlaubt = false;

                            //region Testheftbeschreibungen unterschiedlicher Länder
                            if (this.sessionvariablen.schule.land !== 'nw') {
                                if (t.schwierigkeit === 1) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den EESA`;
                                }
                                if (t.schwierigkeit === 2) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den MSA`;
                                }
                                if (t.schwierigkeit === 3) {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang`;
                                }
                                if (t.schwierigkeit === 1 && t.fach === 'fr') {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den MSA`;
                                }
                                if (t.schwierigkeit === 2 && t.fach === 'fr') {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang`;
                                }
                            }

                            if (this.sessionvariablen.schule.land === 'nw') {
                                if (t.schwierigkeit === 1) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den EESA`;
                                }
                                if (t.schwierigkeit === 2) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den MSA`;
                                }
                                if (t.schwierigkeit === 3) {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang`;
                                }
                                if (t.schwierigkeit === 1 && t.fach === 'fr') {
                                    t.beschreibung = `Bei Französisch ab Klasse 7, findet die Testung im Jahrgang 9 nach 2,5 Lernjahren statt)`;
                                }
                                if (t.schwierigkeit === 2 && t.fach === 'fr') {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang (Französisch ab Klasse 5)`;
                                }
                            }
                            //endregion

                            // NW Französisch 9. Klasse
                            if (this.sessionvariablen.schule.land === 'nw' && this.sessionvariablen.user.accounttyp === 8) {
                                if (t.schwierigkeit === 1 && t.fach === 'fr') {
                                    t.erlaubt = true;
                                    return t;
                                } else {
                                    t.erlaubt = false;
                                    return t;
                                }
                            }

                            // SL Startchancenschulen immer mit TH A
                            if (
                                this.sessionvariablen.schule.land === 'sl' &&
                                [
                                    'SL113S', 'SL131S', 'SL149S', 'SL154S', 'SL253S', 'SL260S', 'SL282S', 'SL314S', 'SL34S', 'SL42S',
                                    'SL44S', 'SL471S', 'SL64S', 'SL65S', 'SL691S', 'SL70S', 'SL800S', 'SL801S', 'SL802S', 'SL803S',
                                    'SL804S', 'SL900S', 'SL901S', 'SL902S', 'SL903AS', 'SL903BS', 'SL904S', 'SL905S'
                                ].includes(this.sessionvariablen.schule.schulnummer)
                            ) {
                                if (t.schwierigkeit === 1) {
                                    t.erlaubt = true;
                                    return t;
                                } else {
                                    t.erlaubt = false;
                                    return t;
                                }
                            }

                            //region Testheftlogik Stammklasse PP
                            if (this.sessionvariablen.schule.land === 'nw') {
                                if (this.sessionvariablen.schule.schulform === 'GY') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = true;
                                }
                                if (this.sessionvariablen.schule.schulform === 'RS') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                                }
                                if (this.sessionvariablen.schule.schulform === 'HS') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                                }
                                if (this.sessionvariablen.schule.schulform === 'GE') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                                }
                                if (this.sessionvariablen.schule.schulform === 'FS') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;

                                    if (t.is_pp === false) t.erlaubt = false; // nur Basistestheft für Förderschulen
                                }
                            }

                            if (this.sessionvariablen.schule.land === 'rp') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = true;
                            }

                            if (this.sessionvariablen.schule.land === 'sl') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;

                                if (t.fach === 'en' || t.fach === 'fr') t.erlaubt = false; // nur CBT für Englisch und Französisch in SL
                            }

                            if (this.sessionvariablen.schule.land === 'hb') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                            }

                            if (this.sessionvariablen.schule.land === 'ni') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                            }

                            if (this.sessionvariablen.schule.land === 'as') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                            }

                            if (this.sessionvariablen.schule.land === 'dg') {
                                if (t.schwierigkeit === 2 && t.fach == 'ma') t.erlaubt = true;
                            }
                            //endregion

                            return t;
                        })
                    )
                );
            }

            // Computerbasierte Variante
            if (this.schulstatus.is_cbt_schule_mathematik === null || this.schulstatus.is_cbt_schule_mathematik === 1) {
                this.testheftVarianten.push(...Utilities.cloneObject(
                        this.testheftliste.filter((t) => {
                            return t.is_cbt === 1
                        }).map((t: any) => {
                            t.cbt = true;
                            t.erlaubt = false;

                            //region Testheftbeschreibungen unterschiedlicher Länder
                            if (this.sessionvariablen.schule.land !== 'nw') {
                                if (t.schwierigkeit === 1) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den EESA`;
                                }
                                if (t.schwierigkeit === 2) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den MSA`;
                                }
                                if (t.schwierigkeit === 3) {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang`;
                                }
                                if (t.schwierigkeit === 1 && t.fach === 'fr') {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den MSA`;
                                }
                                if (t.schwierigkeit === 2 && t.fach === 'fr') {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang`;
                                }
                            }

                            if (this.sessionvariablen.schule.land === 'nw') {
                                if (t.schwierigkeit === 1) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den EESA`;
                                }
                                if (t.schwierigkeit === 2) {
                                    t.beschreibung = `orientiert an den Bildungsstandards der KMK für den MSA`;
                                }
                                if (t.schwierigkeit === 3) {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang`;
                                }
                                if (t.schwierigkeit === 1 && t.fach === 'fr') {
                                    t.beschreibung = `Bei Französisch ab Klasse 7, findet die Testung im Jahrgang 9 nach 2,5 Lernjahren statt)`;
                                }
                                if (t.schwierigkeit === 2 && t.fach === 'fr') {
                                    t.beschreibung = `orientiert am gymnasialen Bildungsgang (Französisch ab Klasse 5)`;
                                }
                            }
                            //endregion

                            // NW Französisch 9. Klasse
                            if (this.sessionvariablen.schule.land === 'nw' && this.sessionvariablen.user.accounttyp === 8) {
                                if (t.schwierigkeit === 1 && t.fach === 'fr') {
                                    t.erlaubt = true;
                                    return t;
                                } else {
                                    t.erlaubt = false;
                                    return t;
                                }
                            }

                            // SL Startchancenschulen immer mit TH A
                            if (
                                this.sessionvariablen.schule.land === 'sl' &&
                                [
                                    'SL113S', 'SL131S', 'SL149S', 'SL154S', 'SL253S', 'SL260S', 'SL282S', 'SL314S', 'SL34S', 'SL42S',
                                    'SL44S', 'SL471S', 'SL64S', 'SL65S', 'SL691S', 'SL70S', 'SL800S', 'SL801S', 'SL802S', 'SL803S',
                                    'SL804S', 'SL900S', 'SL901S', 'SL902S', 'SL903AS', 'SL903BS', 'SL904S', 'SL905S'
                                ].includes(this.sessionvariablen.schule.schulnummer)
                            ) {
                                if (t.schwierigkeit === 1) {
                                    t.erlaubt = true;
                                    return t;
                                } else {
                                    t.erlaubt = false;
                                    return t;
                                }
                            }

                            //region Testheftlogik Stammklasse CBT
                            if (this.sessionvariablen.schule.land === 'nw') {
                                if (this.sessionvariablen.schule.schulform === 'GY') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = true;
                                }
                                if (this.sessionvariablen.schule.schulform === 'RS') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                                }
                                if (this.sessionvariablen.schule.schulform === 'HS') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                                }
                                if (this.sessionvariablen.schule.schulform === 'GE') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;
                                }
                                if (this.sessionvariablen.schule.schulform === 'FS') {
                                    if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                    if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = false;
                                    if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = false;

                                    if (t.is_pp === false) t.erlaubt = false; // nur Basistestheft für Förderschulen
                                }
                            }

                            if (this.sessionvariablen.schule.land === 'rp') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = true;
                            }

                            if (this.sessionvariablen.schule.land === 'sl') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach === 'fr') t.erlaubt = true;
                            }

                            if (this.sessionvariablen.schule.land === 'hb') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                            }

                            if (this.sessionvariablen.schule.land === 'ni') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = false;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = false;
                            }

                            if (this.sessionvariablen.schule.land === 'as') {
                                if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 2 && t.fach !== 'fr') t.erlaubt = true;
                                if (t.schwierigkeit === 3 && t.fach !== 'fr') t.erlaubt = true;
                            }

                            if (this.sessionvariablen.schule.land === 'dg') {
                                if (t.schwierigkeit === 2 && t.fach == 'ma') t.erlaubt = true;
                            }
                            //endregion

                            return t;
                        })
                    )
                );
            }
        }

        if (this.sessionvariablen.projekt.weiche === 'vera5') {
            const testheftSchwierigkeiten: Partial<Record<TFach, number>> = {
                ma: this.schulstatus.testheft_schwierigkeit_mathematik,
                de: this.schulstatus.testheft_schwierigkeit_deutsch
            };

            this.testheftVarianten.push(...Utilities.cloneObject(
                    this.testheftliste.filter((t) => {
                        return t.is_cbt === 1 && t.schwierigkeit === testheftSchwierigkeiten[t.fach];
                    }).map((t: any) => {
                        t.cbt = true;
                        t.erlaubt = true;

                        if (t.schwierigkeit === 1)
                            t.bezeichnung = `Testheft A – Basisniveau`;

                        if (t.schwierigkeit === 2)
                            t.bezeichnung = `Testheft B – erweitertes Niveau`;

                        return t;
                    })
                )
            );
        }

        // Alle Optionsfelder alphabetisch sortieren für die Anzeige
        this.testheftVarianten
            .sort(function (a, b) {
                return (a.bezeichnung).localeCompare(b.bezeichnung);
            })
    }

    public get testliste() {
        return this._testliste;
    }

    public set testliste(value) {
        this._testliste = value;
    }

    public get domaenenliste() {
        return this._domaenenliste;
    }

    public set domaenenliste(value) {
        this._domaenenliste = value;
    }

    public get stufengrenzenliste() {
        return this._stufengrenzenliste;
    }

    public set stufengrenzenliste(value) {
        this._stufengrenzenliste = value;
    }

    public get bistas() {
        return this._bistas;
    }

    public set bistas(value) {
        this._bistas = value;
    }

    public get lhItemebeneVergleichsgruppenliste() {
        return this._lhItemebeneVergleichsgruppenliste;
    }

    public set lhItemebeneVergleichsgruppenliste(value) {
        this._lhItemebeneVergleichsgruppenliste = value;
    }

    public get vergleichsgruppenNwListe() {
        return this._vergleichsgruppenNwListe;
    }

    public set vergleichsgruppenNwListe(value) {
        this._vergleichsgruppenNwListe = value;
    }

    get testheftVarianten() {
        return this._testheftVarianten;
    }

    set testheftVarianten(value) {
        this._testheftVarianten = value;
    }

    public get istVera5TestheftvarianteFestgelegt(): boolean {
        const mathematik = this.schulstatus.testheft_schwierigkeit_mathematik;
        return [1, 2].includes(mathematik) && mathematik === this.schulstatus.testheft_schwierigkeit_deutsch;
    }

    //endregion

    //region Singleton-Pattern
    private static _instance: Veraportal;

    /*
    Die Standardimplementierung eines Singleton-Patterns soll sicherstellen,
    dass Entwickler nicht fälschlicherweise mehrfach Instanzen der Klasse Veraportal erschaffen.<br/>
    Sollte die Seite eigene Skripte enthalten, die nicht auf allen Seiten des Portals ausgeführt werden sollen,
    erbt das seitenspezifische Skript IMMER von Veraportal (siehe Beispiel startseite.php).
     */
    public static getInstance(sessionvariablen: ISessionvariablen): Veraportal {
        return this._instance || (this._instance = new this(sessionvariablen));
    }

    /*
    Der Konstruktor unterstützt keine asynchronen Methodenaufrufe und sollte nur in Ausnahmefällen direkt benutzt werden.<br/>
    Alles Javascript, das im Portal ausgeführt wird, sollte in den (vererbten) Lifecycle-Methoden
    eingebaut werden, um die richtige Ausführungsreihenfolge sicherstellen zu können.
     */
    protected constructor(sessionvariablen: ISessionvariablen) {
        this.sessionvariablen = sessionvariablen;
        this.lifecycle(); // im Konstruktor darf keine asynchrone Methode abgewartet werden
    }

    //endregion

    //region Lifecycle-Methoden
    /*
    Die Methode lifecycle() spielt in der richtigen Reihenfolge Methoden der Klasse und ihrer Kind-Klassen ab.
     */
    private async lifecycle(): Promise<void> {
        await this.onPortalLoad(); // portalweit bei DOMContentLoaded
        await this.onSeiteLoad(); // seitenspezifisch bei DOMContentLoaded
        await this.showLadebildschirm(false, 1000);
        await this.onPortalFinished(); // portalweit wenn Ladebildschirm entfernt
        await this.onSeiteFinished(); // seitenspezifisch wenn Ladebildschirm entfernt (z.B. Modalfenster)
    }

    /*
    Die Methode lifecycleLeave() spielt vor dem Seitenwechsel in der richtigen Reihenfolge Methoden der Klasse und ihrer Kind-Klassen ab.
     */
    public async lifecycleLeave(): Promise<void> {
        await this.onPortalLeave(); // portalweit vor Seitenwechsel
        await this.onSeiteLeave(); // seitenspezifisch vor Seitenwechsel
    }

    /*
    Lifecycle-Methode die überall im Portal direkt nach DOMContentLoaded ausgeführt wird.
     */
    protected async onPortalLoad(): Promise<boolean> {


        // Sentry (Glitchtip) Fehlermeldungen in sentry.projekt-vera.de zur Verbesserung unserer Dienste sammeln
        if (this.sessionvariablen.projekt.sentry_enabled === true) {
            try {
                // @ts-ignore
                Sentry.init({
                    dsn: "https://093f3f987b6c4cbeb2a688d27de5e4b4@sentry.projekt-vera8.de/1",
                    release: `${this.sessionvariablen.projekt.weiche}-portal@${this.sessionvariablen.projekt.portal_version_hash}`,
                    environment: (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1')) ? 'development' : 'production',
                    initialScope: {
                        tags: {
                            page_url: window.location.href,
                            schulnummer: this.sessionvariablen.schule.schulnummer,
                            user_id: this.sessionvariablen.user.user_id
                        },
                        user: {
                            id: `${this.sessionvariablen.schule.schulnummer} (User ${this.sessionvariablen.user.user_id})`
                        }
                    }
                });
            } catch {
                //
            }
        }

        // GET-Parameter für Druckansicht auslesen
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('print') === '1')
            this.druckansicht = true;
        const api = VeraApi.getInstance(this);
        try {
            // Promise.all verwenden, um mehrere Ressourcen parallel abzurufen
            const [schulstatus, domaenenliste, testheftliste, didaktischeKommentareItems, didaktischeKommentareAufgaben, schuelerliste, gruppenliste, schuelerGruppenZuweisungen, testliste, stufengrenzenliste, bistas, lhItemebeneVergleichsgruppenliste, , vergleichsgruppenNwListe] =
                await Promise.all([
                    api.fetchSchulstatus(),
                    api.fetchDomaenenArray(),
                    api.fetchTesthefteArray(),
                    api.fetchDidaktischeKommentareItems(),
                    api.fetchDidaktischeKommentareAufgaben(),
                    api.fetchSchuelerArray(),
                    api.fetchGruppenArray(),
                    api.fetchSchuelerGruppenZuweisungenArray(),
                    api.fetchTestsArray(),
                    api.fetchStufengrenzen(),
                    api.fetchBistas(),
                    api.fetchLhItemebeneVergleichsgruppen(),
                    api.fetchVergleichsgruppenwerte(),
                    api.fetchVergleichsgruppenNw()
                ]);

            // Abgerufene Daten den Instanzvariablen zuweisen
            this.schulstatus = schulstatus;
            this.domaenenliste = domaenenliste;
            this.testheftliste = testheftliste;
            this.schuelerliste = schuelerliste;
            this.gruppenliste = gruppenliste;
            this.schuelerGruppenZuweisungen = schuelerGruppenZuweisungen;
            this.testliste = testliste;
            this.stufengrenzenliste = stufengrenzenliste;
            this.bistas = bistas;
            this.lhItemebeneVergleichsgruppenliste = lhItemebeneVergleichsgruppenliste;
            this.vergleichsgruppenNwListe = vergleichsgruppenNwListe;
            const verwendetGymnasialePilotierungswerte = this.sessionvariablen.projekt.weiche === 'vera8'
                ? this.sessionvariablen.schule.schulform === 'GY'
                : this.sessionvariablen.projekt.weiche === 'vera5' && this.schulstatus.testheft_schwierigkeit_mathematik === 2;
            const isVergleichswertFreigegeben = this.sessionvariablen.projekt.weiche !== 'vera5' || (
                !!this.sessionvariablen.land.kompetenzstufenrueckmeldung_start_am &&
                this.portalzeit >= new Date(this.sessionvariablen.land.kompetenzstufenrueckmeldung_start_am)
            );
            this.tooltipItem = new TooltipItem(this.testheftliste, didaktischeKommentareItems, this.domaenenliste, this.sessionvariablen.schule.land, this.sessionvariablen.projekt.weiche, verwendetGymnasialePilotierungswerte, isVergleichswertFreigegeben);
            this.tooltipAufgabe = new TooltipAufgabe(this.testheftliste, didaktischeKommentareAufgaben, this.domaenenliste, this.sessionvariablen.projekt.weiche);

            // console.log(this.sessionvariablen);
            // console.log(this.schulstatus);
            // console.log(this.testheftVarianten);
        } catch (e) {
            Utilities.errorToSentry(e);
        }

        this.initUiStyling();

        this.hauptmenu = Hauptmenu.getInstance(this);
        if (this.sessionvariablen.projekt.weiche === 'vera8') {
            this.hauptmenu.refresh(
                [
                    {
                        bezeichnung: `Jahrgang verwalten`,
                        icon: `card-list`,
                        href: null,
                        target: null,
                        startTime: null,
                        endTime: null,
                        type: 'left',
                        submenu: [
                            {
                                bezeichnung: `Startseite`,
                                icon: `house`,
                                href: `/startseite.php`,
                                target: null,
                                startTime: null,
                                endTime: null
                            },
                            {
                                bezeichnung: `Statusübersicht`,
                                icon: `list-ul`,
                                href: `/statusuebersicht.php`,
                                target: null,
                                startTime: null,
                                endTime: null
                            },
                            ...(this.sessionvariablen.user.accounttyp === 2 ?
                                    [{
                                        bezeichnung: `Testmodus wählen`,
                                        icon: `pc-display`,
                                        href: `/schule-verwalten.php`,
                                        target: null,
                                        startTime: null,
                                        endTime: null,
                                        enabled: (
                                            (this.schulstatus.is_cbt_schule_mathematik === null) ||
                                            (this.sessionvariablen.land.druckbedarf_ende_am !== null && new Date(this.sessionvariablen.land.druckbedarf_ende_am) > this.portalzeit)
                                        ),
                                        laender: ['nw']
                                    }]
                                    : []
                            ),
                            ...((this.sessionvariablen.user.accounttyp === 2) ?
                                    [{
                                        bezeichnung: `Lerngruppen-Zugänge<br/>verwalten`,
                                        icon: `person-lock`,
                                        href: `/koordinatorenansicht.php`,
                                        target: null,
                                        startTime: null,
                                        endTime: null,
                                        laender: ['ni']
                                    }]
                                    : []
                            ),
                            ...(this.sessionvariablen.user.accounttyp === 2 || ['rp', 'hb', 'sl', 'dg', 'as'].includes(this.sessionvariablen.schule.land) ?
                                    [{
                                        bezeichnung: `Jahrgang importieren`,
                                        icon: `file-earmark-spreadsheet`,
                                        href: `/datenimport.php`,
                                        target: null,
                                        enabled: ((): boolean => {
                                            if (
                                                this.sessionvariablen.schule.land === 'nw' &&
                                                (
                                                    this.schulstatus.is_cbt_schule_mathematik === null ||
                                                    this.schulstatus.is_cbt_schule_deutsch === null ||
                                                    this.schulstatus.is_cbt_schule_englisch === null ||
                                                    this.schulstatus.is_cbt_schule_franzoesisch === null
                                                )
                                            )
                                                return false;
                                            return true;
                                        })(),
                                        startTime: null,
                                        endTime: null
                                    }]
                                    : []
                            ),
                            {
                                bezeichnung: `Schüler verwalten`,
                                icon: `people`,
                                href: `/schuelerverwaltung.php`,
                                target: null,
                                enabled: ((): boolean => {
                                    if (
                                        this.sessionvariablen.schule.land === 'nw' &&
                                        (
                                            this.schulstatus.is_cbt_schule_mathematik === null ||
                                            this.schulstatus.is_cbt_schule_deutsch === null ||
                                            this.schulstatus.is_cbt_schule_englisch === null ||
                                            this.schulstatus.is_cbt_schule_franzoesisch === null
                                        )
                                    )
                                        return false;
                                    return true;
                                })(),
                                startTime: null,
                                endTime: null
                            },
                            // {
                            //     bezeichnung: `Stammklassen und<br/>${(this.sessionvariablen.schule.land !== 'ni') ? `Kurse` : `Lerngruppen`} verwalten`,
                            //     icon: `easel`,
                            //     href: `/gruppen-verwaltung.php`,
                            //     target: null,
                            //      enabled: ((): boolean => {
                            //      if (
                            //          this.sessionvariablen.schule.land === 'nw' &&
                            //          (
                            //              this.schulstatus.is_cbt_schule_mathematik === null ||
                            //              this.schulstatus.is_cbt_schule_deutsch === null ||
                            //              this.schulstatus.is_cbt_schule_englisch === null ||
                            //              this.schulstatus.is_cbt_schule_franzoesisch === null
                            //          )
                            //      )
                            //          return false;
                            //      return true;
                            //  })(),
                            //     startTime: null,
                            //     endTime: null
                            // },
                            ...(this.sessionvariablen.user.accounttyp !== 8 ?
                                    [{
                                        bezeichnung: `Stammklassen und<br/>${(this.sessionvariablen.schule.land !== 'ni') ? `Kurse` : `Lerngruppen`} zuordnen`,
                                        icon: `calendar2`,
                                        href: `/gruppen-zuordnung.php`,
                                        target: null,
                                        enabled: ((): boolean => {
                                            if (
                                                this.sessionvariablen.schule.land === 'nw' &&
                                                (
                                                    this.schulstatus.is_cbt_schule_mathematik === null ||
                                                    this.schulstatus.is_cbt_schule_deutsch === null ||
                                                    this.schulstatus.is_cbt_schule_englisch === null ||
                                                    this.schulstatus.is_cbt_schule_franzoesisch === null
                                                )
                                            )
                                                return false;
                                            return true;
                                        })(),
                                        startTime: null,
                                        endTime: null
                                    }]
                                    : []
                            ),
                            ...(this.sessionvariablen.user.accounttyp === 2 ?
                                    [{
                                        bezeichnung: `Lieferadresse anpassen`,
                                        icon: `buildings`,
                                        href: `/lieferadresse-anpassen.php`,
                                        target: null,
                                        startTime: null,
                                        endTime: this.sessionvariablen.land.druckbedarf_ende_am,
                                        laender: ['nw']
                                    }]
                                    : []
                            ),
                            ...((this.sessionvariablen.user.accounttyp === 2) ?
                                    [{
                                        bezeichnung: `'Franz. Klasse 9'-Zugänge<br/>verwalten`,
                                        icon: `person-lock`,
                                        href: `/koordinatorenansicht.php`,
                                        target: null,
                                        startTime: null,
                                        endTime: null,
                                        laender: ['nw']
                                    }]
                                    : []
                            ),
                            {
                                bezeichnung: `Videotutorials`,
                                icon: `play-btn`,
                                href: `/videotutorials.php`,
                                target: null,
                                startTime: null,
                                endTime: null
                            }
                        ]
                    },
                    {
                        bezeichnung: `Materialien herunterladen`,
                        icon: `download`,
                        href: `/materialien.php`,
                        target: null,
                        startTime: null,
                        endTime: null,
                        type: 'left',
                        submenu: []
                    },
                    {
                        bezeichnung: `Ergebnisse eingeben`,
                        icon: `list-check`,
                        href: `/ergebnisdateneingabe.php`,
                        target: null,
                        enabled: ((): boolean => {
                            if (
                                this.sessionvariablen.schule.land === 'nw' &&
                                (
                                    this.schulstatus.is_cbt_schule_mathematik === null ||
                                    this.schulstatus.is_cbt_schule_deutsch === null ||
                                    this.schulstatus.is_cbt_schule_englisch === null ||
                                    this.schulstatus.is_cbt_schule_franzoesisch === null
                                )
                            )
                                return false;
                            return true;
                        })(),
                        startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                        endTime: null,
                        type: 'left',
                        submenu: []
                    },
                    {
                        bezeichnung: `Rückmeldung erhalten`,
                        icon: `clipboard-data`,
                        href: null,
                        target: null,
                        startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                        endTime: null,
                        type: 'left',
                        submenu: [
                            {
                                bezeichnung: `LH Schüler-Ebene`,
                                icon: `person-lines-fill`,
                                href: `/rueckmeldung-lh-schuelerebene.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                                endTime: null
                            },
                            {
                                bezeichnung: `LH Aufgabenebene`,
                                icon: `bar-chart-steps`,
                                href: `/rueckmeldung-lh-aufgabenebene.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                                endTime: null
                            },
                            {
                                bezeichnung: `LH Flussansicht`,
                                icon: `file-arrow-down`,
                                href: `/rueckmeldung-lh-fluss.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                                endTime: null
                            },
                            {
                                bezeichnung: `VERAcheck`,
                                icon: `clipboard-check`,
                                href: `/rueckmeldung-veracheck.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.kompetenzstufenrueckmeldung_start_am,
                                endTime: null,
                                laender: ['ni']
                            },
                            {
                                bezeichnung: `Kompetenzstufen der SuS`,
                                icon: `table`,
                                href: `/rueckmeldung-ks-schuelerebene.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.kompetenzstufenrueckmeldung_start_am,
                                endTime: null
                            },
                            {
                                bezeichnung: `Berichte anfordern`,
                                icon: `file-pdf`,
                                href: `/rueckmeldung-berichte.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.kompetenzstufenrueckmeldung_start_am,
                                endTime: null
                            },
                        ]
                    }
                ]
            );
        }

        if (this.sessionvariablen.projekt.weiche === 'vera5') {
            const testheftvarianteFestgelegt = this.istVera5TestheftvarianteFestgelegt;

            this.hauptmenu.refresh(
                [
                    {
                        bezeichnung: `Jahrgang verwalten`,
                        icon: `card-list`,
                        href: null,
                        target: null,
                        startTime: null,
                        endTime: null,
                        type: 'left',
                        submenu: [
                            {
                                bezeichnung: `Startseite`,
                                icon: `house`,
                                href: `/startseite.php`,
                                target: null,
                                startTime: null,
                                endTime: null
                            },
                            {
                                bezeichnung: `Testheftvariante wählen`,
                                icon: `building-fill-gear`,
                                href: `/schule-verwalten.php`,
                                target: null,
                                startTime: null,
                                endTime: null,
                                enabled: true,
                                laender: ['nw']
                            },
                            {
                                bezeichnung: `Jahrgang importieren`,
                                icon: `file-earmark-spreadsheet`,
                                href: `/datenimport.php`,
                                target: null,
                                enabled: testheftvarianteFestgelegt,
                                startTime: null,
                                endTime: null
                            },
                            {
                                bezeichnung: `Statusübersicht`,
                                icon: `list-ul`,
                                href: `/statusuebersicht.php`,
                                target: null,
                                startTime: null,
                                endTime: null,
                                enabled: testheftvarianteFestgelegt
                            },
                            {
                                bezeichnung: `Schüler verwalten`,
                                icon: `people`,
                                href: `/schuelerverwaltung.php`,
                                target: null,
                                enabled: testheftvarianteFestgelegt,
                                startTime: null,
                                endTime: null
                            },
                            {
                                bezeichnung: `Stammklassen und<br/>${(this.sessionvariablen.schule.land !== 'ni') ? `Kurse` : `Lerngruppen`} zuordnen`,
                                icon: `calendar2`,
                                href: `/gruppen-zuordnung.php`,
                                target: null,
                                enabled: testheftvarianteFestgelegt,
                                startTime: null,
                                endTime: null
                            },
                            {
                                bezeichnung: `Videotutorials`,
                                icon: `play-btn`,
                                href: `/videotutorials.php`,
                                target: null,
                                startTime: null,
                                endTime: null,
                                enabled: testheftvarianteFestgelegt
                            }
                        ]
                    },
                    {
                        bezeichnung: `Materialien herunterladen`,
                        icon: `download`,
                        href: `/materialien.php`,
                        target: null,
                        startTime: null,
                        endTime: null,
                        type: 'left',
                        submenu: []
                    },
                    {
                        bezeichnung: `Ergebnisse<br/>prüfen`,
                        icon: `list-check`,
                        href: `/ergebnisdateneingabe.php`,
                        target: null,
                        enabled: testheftvarianteFestgelegt,
                        startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                        endTime: null,
                        type: 'left',
                        submenu: []
                    },
                    {
                        bezeichnung: `Rückmeldung erhalten`,
                        icon: `clipboard-data`,
                        href: null,
                        target: null,
                        startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                        endTime: null,
                        enabled: testheftvarianteFestgelegt,
                        type: 'left',
                        submenu: [
                            {
                                bezeichnung: `LH Schüler-Ebene`,
                                icon: `person-lines-fill`,
                                href: `/rueckmeldung-lh-schuelerebene.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                                endTime: null
                            },
                            {
                                bezeichnung: `LH Aufgabenebene`,
                                icon: `bar-chart-steps`,
                                href: `/rueckmeldung-lh-aufgabenebene.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.ergebnisdateneingabe_start_am,
                                endTime: null
                            },
                            {
                                bezeichnung: `LH Flussansicht`,
                                icon: `file-arrow-down`,
                                href: `/rueckmeldung-lh-fluss.php`,
                                target: null,
                                startTime: this.sessionvariablen.land.kompetenzstufenrueckmeldung_start_am,
                                endTime: null
                            }
                        ]
                    }
                ]
            );
        }

        // lifecycleLeave() feuern, sobald ein Seitenwechsel per Link erfolgt
        document.querySelectorAll('body a[href]:not([target])')
            .forEach((anchor) => {
                anchor.addEventListener('click', async (evt) => {
                    evt.preventDefault();
                    await this.lifecycleLeave();
                    let target = (evt.target as HTMLElement).closest(`a`) as HTMLAnchorElement;
                    window.location.href = target.href;
                });
            });
        this.tresor = Tresor.getInstance(this);

        this.benachrichtigungssymbolAktualisieren();

        return true;
    }

    /*
        Lifecycle-Methode nur auf dieser Seite direkt nach DOMContentLoaded ausgeführt wird.
    */
    protected async onSeiteLoad(): Promise<boolean> {

        return false;
    }

    /*
    Lifecycle-Methode die überall im Portal ausgeführt wird, sobald der Ladebildschirm verschwunden ist.
     */
    protected async onPortalFinished(): Promise<boolean> {
        if (this.tresor?.offen === true)
            this.tresor.fillTresorLuecken();

        if (this.druckansicht === true)
            window.print();

        //region Fach und Gruppen-Parameter bei Wechsel auf diese Seiten mit übergeben
        if ((this.sessionvariablen.get['fach'] ?? null) !== null && (this.sessionvariablen.get['gruppeid'] ?? null) !== null) {
            const fach: string = this.sessionvariablen.get['fach'];
            const gruppeid: string = this.sessionvariablen.get['gruppeid'];

            document.querySelectorAll(`a[href='/ergebnisdateneingabe.php']`)
                .forEach((anchor) => {
                    (anchor as HTMLAnchorElement).href = `/ergebnisdateneingabe.php?fach=${fach}&gruppeid=${gruppeid}`;
                });

            document.querySelectorAll(`a[href='/rueckmeldung.php']`)
                .forEach((anchor) => {
                    (anchor as HTMLAnchorElement).href = `/rueckmeldung.php?fach=${fach}&gruppeid=${gruppeid}`;
                });

            document.querySelectorAll(`a[href='/rueckmeldung-lh-schuelerebene.php']`)
                .forEach((anchor) => {
                    (anchor as HTMLAnchorElement).href = `/rueckmeldung-lh-schuelerebene.php?fach=${fach}&gruppeid=${gruppeid}`;
                });

            document.querySelectorAll(`a[href='/rueckmeldung-lh-aufgabenebene.php']`)
                .forEach((anchor) => {
                    (anchor as HTMLAnchorElement).href = `/rueckmeldung-lh-aufgabenebene.php?fach=${fach}&gruppeid=${gruppeid}`;
                });

            document.querySelectorAll(`a[href='/rueckmeldung-lh-fluss.php']`)
                .forEach((anchor) => {
                    (anchor as HTMLAnchorElement).href = `/rueckmeldung-lh-fluss.php?fach=${fach}&gruppeid=${gruppeid}`;
                });

            document.querySelectorAll(`a[href='/rueckmeldung-ks-schuelerebene.php']`)
                .forEach((anchor) => {
                    (anchor as HTMLAnchorElement).href = `/rueckmeldung-ks-schuelerebene.php?fach=${fach}&gruppeid=${gruppeid}`;
                });

            document.querySelectorAll(`a[href='/rueckmeldung-ks-vergleich.php']`)
                .forEach((anchor) => {
                    (anchor as HTMLAnchorElement).href = `/rueckmeldung-ks-vergleich.php?fach=${fach}&gruppeid=${gruppeid}`;
                });
        }
        //endregion

        this.initSchuelerSprungmarken();
        this.initGruppenSprungmarken();
        this.steuerelementeInitialisieren();


        return true;
    }

    /*
    Lifecycle-Methode die auf dieser Seite ausgeführt wird, sobald der Ladebildschirm verschwunden ist.
     */
    protected async onSeiteFinished(): Promise<boolean> {

        return false;
    }

    /*
    Lifecycle-Methode die überall im Portal vor dem Seitenwechsel ausgeführt wird.
     */
    protected async onPortalLeave(): Promise<boolean> {
        return true;
    }

    /*
    Lifecycle-Methode die auf dieser Seite vor dem Seitenwechsel ausgeführt wird.
     */
    protected async onSeiteLeave(): Promise<boolean> {

        return false;
    }

    /*
    Blendet den Ladebildschirm (div.loading) ein und aus.
     */
    private async showLadebildschirm(einblenden: boolean = true, ms: number = 2000): Promise<boolean> {
        document.querySelector(`body`).removeAttribute('style');

        await Utilities.delay(ms);

        if (einblenden === true) {
            document.querySelector(`body > div.loading`)?.classList.add('active');
        } else {
            document.querySelector(`body > div.loading`)?.classList.remove('active');
        }
        await Utilities.delay(500); // Auf CSS-Transition warten

        return true;
    }

    //endregion

    /*
    Checkboxen, Radiobuttons und Selectfelder brauchen zur Anpassung des CSS Wrapper-Klassen.<br/>
    Die Methode initUiStyling() fügt diese div automatisch um jedes entsprechende Steuerelement herum hinzu.
     */
    public initUiStyling() {
        let checkboxes: NodeListOf<HTMLInputElement> = document.querySelectorAll(`input[type='radio'], input[type='checkbox']`);
        for (let i = 0; i < checkboxes.length; i++) {
            try {
                let checkbox = checkboxes[i];
                let label = checkbox.closest('label');
                if (!label) {
                    label = document.createElement('label');
                    checkbox.parentNode.insertBefore(label, checkbox);
                    label.appendChild(checkbox);
                }
                let randomId = 'cb' + Math.floor(Math.random() * (99999 - 11111 + 1) + 11111).toString();
                if (label) {
                    if (checkbox.type === 'checkbox') label.classList.add('checkbox-wrapper');
                    if (checkbox.type === 'radio') label.classList.add('radio-wrapper');
                    if (checkbox.disabled) label.setAttribute('disabled', 'disabled');
                    if (!checkbox.id) checkbox.id = randomId;
                    if (!label.getAttribute('for')) label.setAttribute('for', checkbox.id);
                    if (!label.querySelector('span.checkmark')) {
                        let span = document.createElement('span');
                        span.className = 'checkmark';
                        label.appendChild(span);
                    }
                }
            } catch (e) {
                Utilities.errorToSentry(e);
            }
        }
    }

    //region portalweite Definition von Selectbox-Aussehen und Verhalten (Testhefte / Gruppen ...)
    public tsGruppeRenderOptions = {
        option: (data: { icon: string; text: string; gruppeid: string; typ: TGruppentyp }, escape) => {
            return `<div class="gruppe-option">
                        <div class="icon">
                        ${(data.icon !== null) ? `
                            <svg role='graphics-symbol'>
                                <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#${data.icon}'/>
                            </svg>
                        ` : ``}
                        </div>
                        <div class="text">
                            <div class="bezeichnung">${data.text}</div>
                        </div>
                        <div class="options">
                        ${((data.gruppeid ?? null) !== null && this.sessionvariablen.schule.land !== 'ni') ? `
                            ${((data.typ ?? null) === 'STAMMKLASSE') ? `
                            <button class="edit-stammklasse-btn" aria-label="Stammklasseneigenschaften anpassen" data-tooltip="${Tooltip.html`
                                <p><strong>Stammklasseneigenschaften anpassen</strong></p>
                            `}" data-gruppeid="${data.gruppeid}">
                                <svg role='graphics-symbol'>
                                    <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gear-fill'/>
                                </svg>
                            </button>` : ``}
                            ${((data.typ ?? null) === 'KURS') ? `
                            <button class="edit-kurs-btn" aria-label="Kurseigenschaften anpassen" data-tooltip="${Tooltip.html`
                                <p><strong>Kurseigenschaften anpassen</strong></p>
                            `}" data-gruppeid="${data.gruppeid}">
                                <svg role='graphics-symbol'>
                                    <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gear-fill'/>
                                </svg>
                            </button>` : ``}
                            ${((data.typ ?? null) === 'LERNGRUPPE') ? `
                            <button class="edit-lerngruppe-btn" aria-label="Lerngruppeneigenschaften anpassen" data-tooltip="${Tooltip.html`
                                <p><strong>Lerngruppeneigenschaften anpassen</strong></p>
                            `}" data-gruppeid="${data.gruppeid}">
                                <svg role='graphics-symbol'>
                                    <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gear-fill'/>
                                </svg>
                            </button>` : ``}
                        ` : ``}
                        </div>
                    </div>`;
        },
        optgroup_header: function (data, escape) {
            return '<div class="optgroup-header">' + escape(data.label) + '</div>';
        }
    };

    public gruppeOptionHTML = (
        {gruppe_id, bezeichnung, typ, selected}: IGruppenDB & { selected: boolean }
    ) => {
        return `<option value="${gruppe_id}" ${((selected ?? false)) ? `selected="selected"` : ``} ${(typ === 'STAMMKLASSE') ? `data-icon="people-fill"` : `data-icon="calendar2-week"`} data-gruppeid="${gruppe_id}" data-typ="${typ}">${bezeichnung}</option>`;
    };

    public tsTestheftOptions = {
        create: false,
        allowEmptyOption: true,
        controlInput: null,
        searchField: [],
        render: {
            option: function (data, escape) {
                return `<div class="testheft-option">
                            <div class="icon">
                            ${(data.icon !== null) ? `
                                <svg role='graphics-symbol'>
                                    <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#${data.icon}'/>
                                </svg>
                            ` : ``}
                            </div>
                            <div class="text">
                                <div class="bezeichnung">${data.text}</div>
                                <div class="beschreibung">${(data.beschreibung !== undefined) ? `${data.beschreibung}` : ``}</div>
                            </div>
                        </div>`;
            }
        }
    };

    public testheftOptionHTML = (
        {testheft_id, bezeichnung, beschreibung, cbt, selected, erlaubt}: (ITesthefteDB & { cbt: boolean, beschreibung: string, erlaubt: boolean, selected: boolean })
    ) => {
        return `
<option value="${testheft_id}${(cbt === true) ? `cbt` : `pp`}"
    data-testheftid="${testheft_id}"
    data-is-pp="${(cbt === false) ? `1` : `0`}"
    data-is-cbt="${(cbt === true) ? `1` : `0`}"
    data-beschreibung="${beschreibung}"
    data-icon="${(cbt === true) ? `display` : `journal-text`}"
    ${((selected ?? false) === true) ? `selected="selected"` : ``}
    ${((erlaubt ?? false) === false) ? `disabled="disabled"` : ``}
>
    ${bezeichnung} ${(this.sessionvariablen.projekt.weiche === 'vera5') ? `` : (cbt === true) ? `CBT` : `PP`}
</option>`;
    };

    //endregion

    public benachrichtigungssymbolAktualisieren() {
        if (document.querySelector(`#menu-benachrichtigungscenter-btn`) === null)
            return false;

        let benachrichtigungsanzahl = 0;
        let benachrichtigungsgrad = null;
        if (this.schulstatus === null)
            return false;

        // Benachrichtigungszähler
        if (this.schulstatus.is_ok_schueler_ohne_geschlecht_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (this.schulstatus.is_ok_schueler_ohne_stammklasse_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (this.schulstatus.is_ok_stammklassen_ohne_schueler_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (this.schulstatus.is_ok_kurse_ohne_schueler_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (
            this.schulstatus.is_ok_schueler_ohne_mathematik_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_mathematik_testheft_warnung)
        ) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (
            this.schulstatus.is_ok_schueler_ohne_deutsch_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_deutsch_testheft_warnung)
        ) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (
            this.schulstatus.is_ok_schueler_ohne_englisch_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_englisch_testheft_warnung)
        ) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (
            this.schulstatus.is_ok_schueler_ohne_franzoesisch_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_franzoesisch_testheft_warnung)
        ) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (this.schulstatus.is_ok_unvollstaendige_tests_mathematik_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (this.schulstatus.is_ok_unvollstaendige_tests_deutsch_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (this.schulstatus.is_ok_unvollstaendige_tests_englisch_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }
        if (this.schulstatus.is_ok_unvollstaendige_tests_franzoesisch_warnung === 0) {
            benachrichtigungsanzahl++;
            benachrichtigungsgrad = 'warnung';
        }

        if (benachrichtigungsgrad !== null) {
            document.querySelector(`#menu-benachrichtigungscenter-btn`)?.classList.add(benachrichtigungsgrad);
            document.querySelector(`#menu-benachrichtigungscenter-btn span.benachrichtigungen`).innerHTML = benachrichtigungsanzahl.toString();
        }
    }

    private initSchuelerSprungmarken() {
        let sprungmarkenArr: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(`a.sprungmarke-schueler`);
        if (sprungmarkenArr.length === 0) return;

        for (let i = 0; i < sprungmarkenArr.length; i++) {
            let schuelernr: number = parseInt(sprungmarkenArr[i].getAttribute('data-nr')) ?? null;
            if (schuelernr === null) continue;

            const ziel = (sprungmarkenArr[i].href.includes('schuelerverwaltung.php') === true) ? 'Schülerverwaltung'
                : (sprungmarkenArr[i].href.includes('gruppen-zuordnung.php') === true) ? 'Gruppenzuordnung'
                    : (sprungmarkenArr[i].href.includes('ergebnisdateneingabe.php') === true) ? 'Ergebnisdateneingabe'
                        : 'Zielseite';
            sprungmarkenArr[i].dataset.tooltip = Tooltip.content`
                <p><strong>Zu Schüler:in ${schuelernr.toString().padStart(3, '0')} springen</strong></p>
                <p>Öffnet die Schüler:in direkt in der ${ziel}.</p>
            `;
            sprungmarkenArr[i].setAttribute('aria-label', `Zu Schüler:in ${schuelernr.toString().padStart(3, '0')} in der ${ziel} springen`);
            sprungmarkenArr[i].href += `${(sprungmarkenArr[i].href.includes('?') === false) ? `?` : `&`}schuelernr=${schuelernr}`;
        }
    }

    private initGruppenSprungmarken() {
        let sprungmarkenArr: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(`a.sprungmarke-gruppe`);
        if (sprungmarkenArr.length === 0) return;

        for (let i = 0; i < sprungmarkenArr.length; i++) {
            let gruppenbezeichnung: string = sprungmarkenArr[i].getAttribute('data-bezeichnung') ?? null;
            if (gruppenbezeichnung === null) continue;

            sprungmarkenArr[i].dataset.tooltip = Tooltip.content`
                <p><strong>Zur Gruppe ${gruppenbezeichnung} springen</strong></p>
                <p>Öffnet die Gruppe direkt in der Gruppenzuordnung.</p>
            `;
            sprungmarkenArr[i].setAttribute('aria-label', `Zur Gruppe ${gruppenbezeichnung} in der Gruppenzuordnung springen`);
            sprungmarkenArr[i].href += `${(sprungmarkenArr[i].href.includes('?') === false) ? `?` : `&`}gruppenbezeichnung=${gruppenbezeichnung}`;
        }
    }

    private kannVera5GruppenmodalOeffnen(): boolean {
        if (this.sessionvariablen.projekt.weiche !== 'vera5' || this.istVera5TestheftvarianteFestgelegt)
            return true;

        const hinweisModal = new Modal(this);
        hinweisModal.show({
            title: `Testheftvariante noch nicht festgelegt`,
            body: `<p>Legen Sie zuerst unter <a href="/schule-verwalten.php">Testheftvariante wählen</a> die schulweite Testheftvariante fest.</p>`,
            hasSubmit: false,
            hasCancel: true,
            cancelText: `OK`
        });
        return false;
    }

    public stammklasseEditieren(gruppeId: number) {
        if (this.kannVera5GruppenmodalOeffnen() === false)
            return;

        let stamklasseEditierenModal = new StammklasseAnpassenModal(this, gruppeId);
        stamklasseEditierenModal.show({
            id: "modal-stammklasse-anpassen",
            title: "Stammklasse anlegen",
            body: `XXX`,
            hasSubmit: true,
            hasCancel: true,
            hasBestaetigung: false,
            width: (this.sessionvariablen.schule.land !== 'ni') ? 1000 : 650,
            cancelText: "Abbrechen",
            submitText: "Stammklasse anlegen"
        });
    }

    public kursEditieren(gruppeId: number) {
        if (this.kannVera5GruppenmodalOeffnen() === false)
            return;

        let kursEditierenModal = new KursAnpassenModal(this, gruppeId);
        kursEditierenModal.show({
            id: "modal-kurs-anpassen",
            title: "Kurs anlegen",
            body: `XXX`,
            hasSubmit: true,
            hasCancel: true,
            hasBestaetigung: false,
            cancelText: "Abbrechen",
            submitText: "Kurs anlegen"
        });
    }

    public lerngruppeEditieren(gruppeId: number) {
        let lerngruppeEditierenModal = new LerngruppeAnpassenModal(this, gruppeId);
        lerngruppeEditierenModal.show({
            id: "modal-lerngruppe-anpassen",
            title: "Lerngruppe anlegen",
            body: `XXX`,
            hasSubmit: true,
            hasCancel: true,
            hasBestaetigung: false,
            cancelText: "Abbrechen",
            submitText: "Lerngruppe anlegen"
        });
    }

    /*
    portalweit verschiedene Klick-Events für Buttons initialisieren
    z.B. "Stammklasse anlegen", "Kurs anlegen", "Klarnamen aktivieren" ...
*/
    private steuerelementeInitialisieren() {
        // Modalfenster öffnen: Stammklasse anlegen
        document.querySelector(`button.stammklasse-hinzufuegen-button`)
            ?.addEventListener('click', () => {
                if (this.kannVera5GruppenmodalOeffnen() === false)
                    return;

                let modal = new StammklasseAnpassenModal(this);
                modal.show({
                    id: "modal-stammklasse-anpassen",
                    title: "Stammklasse anlegen",
                    body: `XXX`,
                    hasSubmit: true,
                    hasCancel: true,
                    hasBestaetigung: false,
                    width: (this.sessionvariablen.schule.land !== 'ni') ? 1000 : 650,
                    cancelText: "Abbrechen",
                    submitText: "Stammklasse anlegen"
                });
            });

        // Modalfenster öffnen: Kurs anlegen
        document.querySelector(`button.kurs-hinzufuegen-button`)
            ?.addEventListener('click', () => {
                if (this.kannVera5GruppenmodalOeffnen() === false)
                    return;

                let modal = new KursAnpassenModal(this);
                modal.show({
                    id: "modal-kurs-anpassen",
                    title: "Kurs anlegen",
                    body: `XXX`,
                    hasSubmit: true,
                    hasCancel: true,
                    hasBestaetigung: false,
                    cancelText: "Abbrechen",
                    submitText: "Kurs anlegen"
                });
            });

        // Gruppe bearbeiten-Buttons
        document.querySelectorAll(`:not(.gruppe-option) button.edit-stammklasse-btn`)
            .forEach(b => b.addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.stammklasseEditieren(parseInt((evt.target as HTMLElement)?.getAttribute('data-gruppeid')) ?? null);
                })
            );
        document.querySelectorAll(`:not(.gruppe-option) button.edit-kurs-btn`)
            .forEach(b => b.addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.kursEditieren(parseInt((evt.target as HTMLElement)?.getAttribute('data-gruppeid')) ?? null)
                })
            );
        document.querySelectorAll(`:not(.gruppe-option) button.edit-lerngruppe-btn`)
            .forEach(b => b.addEventListener('click', (evt) => {
                    console.log('lololololo')
                    evt.stopPropagation();
                    this.lerngruppeEditieren(parseInt((evt.target as HTMLElement)?.getAttribute('data-gruppeid')) ?? null)
                })
            );

        // Schule zurücksetzen und SuS, Gruppen und Klarnamen löschen
        document.querySelector(`button#schule-zuruecksetzen-btn`)
            ?.addEventListener('click', () => {
                let resetSchuleModal = new Modal(this);
                let resetSchuleModalPromise = resetSchuleModal.show({
                    title: `Schule vollständig zurücksetzen`,
                    body: `
                    <p>
                        Möchten Sie alle bisher eingegebenen Schülerinformationen, Gruppen und Klarnamen Ihres Jahrganges wirklich vollständig zurücksetzen?
                        Dann bestätigen Sie Ihre Entscheidung durch die Eingabe von <i>"OK"</i> und klicken Sie auf "Schule zurücksetzen".<br/>
                        Sie können die Eingaben nur zurücksetzen, wenn bisher noch keine Ergebnisdaten eingegeben wurden.
                    </p>
                `,
                    width: 600,
                    hasSubmit: true,
                    hasCancel: true,
                    hasBestaetigung: true,
                    submitText: 'Schule zurücksetzen',
                    cancelText: 'Abbrechen'
                });
                resetSchuleModalPromise.then(async (modalantwort) => {
                    if (modalantwort === true) {
                        try {
                            const api = VeraApi.getInstance(this);
                            await api.resetSchule(this.sessionvariablen.schule.schulnummer);
                            await Utilities.delay(1000);
                            window.location.reload();
                        } catch {
                            //
                        }
                    }
                });
            });
    }


    //region portalabhängige Utility-Funktionen
    /*
    Gibt das Eigenschaftenobjekt des Domänenkürzels zurück.<br/>
    z.B. 'ma-za' -> result.bezeichnung / result.kurzbezeichnung ...
     */
    protected domaeneEigenschaften(domaenenKuerzel: string): IDomaenenDB {
        let domaene: IDomaenenDB = this.domaenenliste
            .filter(d => d.domaene === domaenenKuerzel)[0] ?? null;

        if (domaene === null) console.error('Domänenkürzel nicht bekannt');
        return domaene;
    }

    protected async initSortierungSpaltenkoepfe() {
        const spaltenkoepfe = document.querySelectorAll<HTMLElement>('[data-sort-kategorie]');

        spaltenkoepfe.forEach(spaltenkopf => {
            const sortIcon = document.createElement('div');
            sortIcon.className = 'sort-icon';
            const caret = document.createElement('span');
            caret.className = 'caret';
            caret.textContent = '▲▼';
            sortIcon.prepend(caret);
            spaltenkopf.appendChild(sortIcon);

            spaltenkopf.dataset.tooltip = Tooltip.content`
                <p><strong>Spalte sortieren</strong></p>
                <p>Klicken Sie auf den Spaltenkopf, um die Sortierreihenfolge zu ändern.</p>
            `;

            spaltenkopf.addEventListener('click', (evt) => {
                const target = evt.target as HTMLElement;
                const closestSpaltenkopf = target.closest<HTMLElement>('[data-sort-kategorie]')!;
                let richtung = closestSpaltenkopf.getAttribute('data-sort-richtung') || 'asc';

                document.querySelectorAll('span.caret').forEach(caret => caret.remove());

                if (richtung === 'asc') {
                    document.querySelectorAll('[data-sort-richtung]').forEach(el => el.removeAttribute('data-sort-richtung'));
                    closestSpaltenkopf.setAttribute('data-sort-richtung', 'desc');
                    const caret = document.createElement('span');
                    caret.className = 'caret';
                    caret.textContent = '▼';
                    closestSpaltenkopf.querySelector('div.sort-icon')?.prepend(caret);
                } else {
                    document.querySelectorAll('[data-sort-richtung]').forEach(el => el.removeAttribute('data-sort-richtung'));
                    closestSpaltenkopf.setAttribute('data-sort-richtung', 'asc');
                    const caret = document.createElement('span');
                    caret.className = 'caret';
                    caret.textContent = '▲';
                    closestSpaltenkopf.querySelector('div.sort-icon')?.prepend(caret);
                }

                document.dispatchEvent(new CustomEvent('refresh-rueckmeldung'));
            });
        });
    }

    public excelClipboardToArray(evt: ClipboardEvent): string[][] {
        try {
            evt.stopPropagation();
            evt.preventDefault();

            // Clipboard extrahieren und escapen
            // @ts-ignore
            let clipboardData = evt.clipboardData || window.clipboardData;
            let plaintextEscaped = clipboardData.getData('text/plain')
                .replace(/[^a-z0-9äüöß\-_ .\n\t]/gim, '')
                .replace(/[ ]{2,}/gim, ' ')
                .trim();

            // Clipboard zu zweidimensionalem Array umwandeln
            let clipboardTable: string[][] = plaintextEscaped.split('\n')
                .map((row: string): string[] => {
                    return row.trim()
                        .split('\t')
                        .map((cell: string): string => {
                            let cellEscaped = cell.trim();
                            return (cellEscaped.length > 0) ? cellEscaped : null;
                        }) ?? []
                });

            // normales Paste ohne Zeilenumbrüche
            if (clipboardTable.length === 1 && clipboardTable[0].length === 1) {
                (evt.target as HTMLInputElement).value = plaintextEscaped.substring(0, 20).trim();
                return [];
            }

            if (clipboardTable.length > 0) {
                return clipboardTable;
            } else {
                return [];
            }

        } catch (e) {
            return [];
        }
    }

    //endregion
}
